import VehicleFourFeaturesBlock from "./VehicleFourFeaturesBlock";

export default VehicleFourFeaturesBlock;
